<template>
    <div class="max">
        <div v-show="formLoading">
            <div class="d-flex justify-content-center  py-5">
                <b-spinner label="Spinning" class="text-primary"></b-spinner>
            </div>
        </div>
        <div v-show="!formLoading">
            <b-row v-if="sectionInformation">
                <b-col cols="12">
                    <div class="d-flex  flex-column">
                        <div class="d-flex justify-content-start overflow-auto">
                            <div>
                                <b-table
                                    responsive
                                    bordered
                                    :items="[sectionInformation]"
                                    :fields="fields"
                                    class="border "
                                >
                                </b-table>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex mb-2">
                        <div class="flex-grow-1 d-flex align-items-center">
                            <h5 class="font-weight-bold m-0">{{ $t('students').toUpper() }}</h5>
                        </div>
                        <div class="d-flex" v-if="studentData.length">
                            <excel-export :data="studentData" :headings="studentFieldsJson" :file-name="sectionInformation.course_name+' '+sectionInformation?.start_date"></excel-export>
                        </div>
                    </div>
                    <datatable
                        :isLoading.sync="datatable.isLoading"
                        :columns="datatable.columns"
                        :rows="datatable.rows"
                        :total="datatable.total"
                        :queryParams="datatable.queryParams"
                        :lineNumbers="true"
                        :show-paginate="false"
                        @on-page-change="onPageChange"
                        @on-sort-change="onSortChange"
                        @on-per-page-change="onPerPageChange"
                        v-show="datatable.showTable"
                    >
                    </datatable>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
// Components

// Services
import StudentSession from "@/services/StudentSessionService"
import Datatable from "@/components/datatable/Datatable.vue";

import qs from "qs";
import ExcelExport from "@/components/interactive-fields/ExcelExport.vue";

// Other
export default {
    components: {
        ExcelExport,
        Datatable,
    },
    props: {
        formId: {
            type: Number
        },
        selectedSession: {
            type: Object,
        }
    },
    data() {
        return {
            sectionInformation:null,
            fields: [
                {
                    key: 'course_name',
                    label:this.$t('course_name'),
                },
                {
                    key: 'classroom_name',
                    label: this.$t('classroom'),
                },
                {
                    key: 'instructor_name',
                    label: this.$t('instructor_name'),
                },
                {
                    key: 'instructor_surname',
                    label: this.$t('instructor_surname'),
                },
                {
                    key: 'start_date',
                    label: this.$t('start_date'),
                },
                {
                    key: 'end_date',
                    label: this.$t('end_date'),
                },

            ],
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: this.$t('id'),
                        field: '_id',
                        hidden: true,
                    },
                    {
                        label: this.$t('student_id'),
                        field: 'student_number',
                        hidden: false,
                        thClass: 'text-center',
                    },
                    {
                        label: this.$t('name'),
                        field: 'student_name',
                        hidden: false,
                        thClass: 'text-center',
                    },
                    {
                        label: this.$t('surname'),
                        field: 'student_surname',
                        hidden: false,
                        thClass: 'text-center',
                    },
                    {
                        label: this.$t('email'),
                        field: 'student_email',
                        hidden: false,
                        thClass: 'text-center',
                    },
                    {
                        label: this.$t('Total Absences'),
                        field: 'absences',
                        hidden: false,
                        thClass: 'text-center',
                    },
                    {
                        label: this.$t('Total Late'),
                        field: 'lates',
                        hidden: false,
                        thClass: 'text-center',
                    },
                    {
                        label: this.$t('score'),
                        field: 'score',
                        hidden: false,
                        thClass: 'text-center',
                    },
                    {
                        label: this.$t('Comment'),
                        field: 'comment',
                        hidden: false,
                        thClass: 'text-center',
                    },
                    {
                        label: this.$t('Conditional Pass'),
                        field: 'conditionally_passed',
                        hidden: false,
                        thClass: 'text-center',
                        formatFn:(value)=>{
                           return  value ? this.$t('yes'):this.$t('no')
                        }
                    },

                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    page: 1,
                    limit: -1
                }
            },
            studentData:[],
            formLoading: false,
            studentFieldsJson: {
                'student_number':'Student ID',
                'student_name': 'First Name',
                'student_surname': 'Last Name',
                'student_email': 'E-mail',
                'absences': 'Total Absences',
                'lates': 'Total Late',
                'score': 'Score',
                'comment': 'Comment',
                'conditionally_passed': 'Conditional Pass'
            },
        }
    },
    created() {
       this.getStudentList()
    },
    methods: {
        filter() {
            this.datatable.queryParams.page = 1;
            this.getStudentList();
        },
        filterClear() {
            this.datatable.queryParams.filter = {};
            this.getStudentList();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getStudentList();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getStudentList();
        },
        onSortChange(params) {
            const sortType = params[0].type == "desc" ? "-" : "";
            this.datatable.queryParams.sort = sortType + params[0].field;
            this.getStudentList();
        },
        getStudentList() {
            this.datatable.isLoading = true;
            this.datatable.showTable = true;
            this.formLoading = true;
            const config={
                 params:{
                     filter:{
                         session_id:this.formId,
                         is_paid: 1
                     },
                     limit:-1
                 },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            }
            StudentSession.getAll(config)
                .then(response => {
                    this.datatable.total = response.data.pagination.total;
                    this.studentData = response.data.data;
                    this.datatable.rows = response.data.data
                    this.sectionInformation=this.selectedSession;
                    if (this.$route.path.startsWith('/esl/instructor')) {
                        const index = this.fields.findIndex(f => f.key === 'instructor_surname');
                        this.fields.splice(index, 1);
                    }
                })
                .finally(() => {
                    this.formLoading = false;
                    this.datatable.isLoading = false;
                })
        },
    }
}
</script>
